var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_11239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8136 21V19C16.8136 17.9391 16.3924 16.9217 15.6426 16.1716C14.8929 15.4214 13.876 15 12.8157 15H5.81958C4.7593 15 3.74244 15.4214 2.99271 16.1716C2.24297 16.9217 1.82178 17.9391 1.82178 19V21",
    stroke: "#3D4744",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31763 11C11.5256 11 13.3154 9.20914 13.3154 7C13.3154 4.79086 11.5256 3 9.31763 3C7.1097 3 5.31982 4.79086 5.31982 7C5.31982 9.20914 7.1097 11 9.31763 11Z",
    stroke: "#3D4744",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.813 11L19.8119 13L23.8097 9",
    stroke: "#3D4744",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_11239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.822266,
    width: 23.9868,
    height: 24,
    rx: 11.9934,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheckIcon);
export default __webpack_public_path__ + "static/media/user_check_icon.35fa72eea8fcb570cf1b2a8ea6547e86.svg";
export { ForwardRef as ReactComponent };